import React from 'react';
import styled from 'styled-components';
import { asStyledComponent } from '@clds/component-enhancer';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';
export const StyledGroupHeader = styled.div `
  ${({ size, tone }) => typography[size][tone]};
  padding: ${globalTheme.spacing.xs} ${globalTheme.spacing.sm};
`;
export const GroupHeader = asStyledComponent((props) => (React.createElement(StyledGroupHeader, Object.assign({ size: "sm", tone: "lowContrast" }, props))));
//# sourceMappingURL=GroupHeader.js.map